export function Login({ reason }) {
  const mensaje = {
    no_projects: 'Tu usuario de GitLab no tiene acceso a ningún proyecto registrado en la consola.',
    authz_unavailable: 'No se han podido consultar tus permisos en GitLab. Inténtalo en un momento.',
    oidc_unavailable: 'El proveedor de identidad no está disponible.',
    not_allowed: 'Tu usuario de GitLab no está autorizado a usar esta consola. Es una herramienta '
      + 'interna con acceso restringido; pide que te añadan si necesitas entrar.',
  }[reason]

  return (
    <div className="login">
      <div className="login-box">
        <img className="brand-mark" src="/icono.svg" alt="" width="56" height="56" />
        <h1>Consola CloudTree</h1>
        <p>Entornos de desarrollo</p>
        {mensaje && <div className="alert error" style={{ marginBottom: 20, textAlign: 'left' }}>{mensaje}</div>}
        <a className="btn" href="/auth/login">Continuar con GitLab</a>
      </div>
    </div>
  )
}
